/* eslint-disable vue/match-component-file-name */
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
	routes: [
		{
			path: '/',
			component: Vue.component('GuestPlaylistView', require('./pages/GuestPlaylistView.vue').default)
		}
	]
});
